import { SxProps } from '@mui/material';

export const formContainer: SxProps = {
  p: 3,
};
